module.exports = __webpack_public_path__ + "img/clemens-theisen-1.3efa38cd.jpg";